/* eslint-disable no-magic-numbers */

/**
 * Takes a decimal number and returns one (as string) that is at max x decimal places
 * @param num - The string representation of a number to process
 * @param dp - The maximum decimal places to show. defaults to 2.
 */
export const maxDecimalPlaces = (num: string, dp = 2) => {
  const val = parseFloat(num);
  if (isNaN(val) || num.indexOf('.') === -1) {
    return num;
  }

  return num.substring(0, num.indexOf('.') + dp + 1);
};

/**
 * Takes a decimal number and returns one (as string) that is at least x decimal places
 * @param num - The string representation of a number to process
 * @param dp - The minimum decimal places to show. defaults to 2.
 */
export const minDecimalPlaces = (num: string, dp = 2) => {
  const val = parseFloat(num);
  if (isNaN(val)) {
    return num;
  }
  if (num.indexOf('.') !== -1) {
    return val.toFixed(Math.max(dp, (val.toString().split('.')[1] || []).length));
  } else {
    return `${num}.${[...new Array(dp)].map(() => '0').join('')}`;
  }
};

/**
 * Takes the given number and returns a new one (as string) rounded to the specified number of decimal places
 * @param n - Number to round
 * @param dp - Decimal places to round to
 */
export const roundToDp = (n: number | string, dp = 2) => {
  const num = typeof n === 'string' ? parseFloat(n) : n;
  const multiplier = +'1'.padEnd(dp + 1, '0'); // 10 or 100 or 1000 or etc
  return (Math.round(num * multiplier) / multiplier).toFixed(dp);
};
